<template>
	<div class="tw3-flex tw3-justify-center">
		<Form
			v-slot="$form"
			class="tw3-flex tw3-flex-col tw3-gap-4 tw3-w-full sm:w-56"
			:initialValues="initialValues"
			:resolver="resolver"
			@submit="submitVin"
		>
			<div class="tw3-flex tw3-flex-wrap tw3-items-start tw3-gap-2">
				<div class="tw3-flex tw3-flex-1 tw3-flex-col tw3-gap-1">
					<InputMask
						fluid
						mask="*****************"
						name="vin"
						placeholder="_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _"
					/>
					<Message
						v-if="$form.vin?.invalid"
						severity="error"
						size="small"
						variant="simple"
					>
						{{ $form.vin.error?.message }}
					</Message>
				</div>
				<div class="tw3-flex tw3-flex-col tw3-gap-1">
					<Button label="Decode VIN" severity="secondary" type="submit" />
				</div>
			</div>
		</Form>
	</div>
</template>

<script setup>
import { Form } from '@primevue/forms';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import Button from 'primevue/button';
import InputMask from 'primevue/inputmask';
import Message from 'primevue/message';
import { ref } from 'vue';
import { z } from 'zod';

const emit = defineEmits(['submit']);

const initialValues = ref({
	vin: ''
});

const resolver = ref(
	zodResolver(
		z.object({
			vin: z.string().min(1, { message: 'Vin is required.' })
		})
	)
);

const submitVin = form => {
	const { valid, values } = form;

	if (valid) {
		emit('submit', values.vin);
	}
};
</script>
